export enum AccountType {
  User = 'USER',
  Company = 'COMPANY',
}
